<template>
  <div>
    <div
      class='clearfix yxt-user-advance-wrap pr20'
    >
      <yxt-row onsubmit='return false' class="mb16" type='flex'>
        <yxt-form
          style='flex:1'
          :inline='true'
        >
          <div class='d-in-flex'>
            <yxt-input
              :placeholder="$t('pc_biz_udp_tip_searchCommon')"
              v-model='searchValue'
              class='ml12'
              style='width: 190px;'
              searchable
              @search='search'
            ></yxt-input>
          </div>
        </yxt-form>
      </yxt-row>
      <yxt-table
        ref='userTable'
        @select-all='selectAllUser'
        @select='selectUser'
        :height='tableHeight'
        v-loading='loading'
        class='yxt-user-table'
        row-key="id"
        :data='users'
      >
        <template slot='empty'>
          <div style='line-height:normal'>
            <yxt-empty />
          </div>
        </template>
        <yxt-table-column
          :show-overflow-tooltip='false'
          class-name='yxtbiz-table-selection'
          type='selection'
          width='40'
        ></yxt-table-column>
        <yxt-table-column :label="$t('pc_biz_core_lbl_name')" :show-overflow-tooltip="true" popover-html>
          <template slot-scope='scope'>
            <yxtbiz-user-name :name='scope.row.fullname' />
          </template>
        </yxt-table-column>
        <yxt-table-column
          :show-overflow-tooltip="true"
          :label='$t("pc_biz_core_lbl_accnum")'
          prop='username'
        ></yxt-table-column>
        <yxt-table-column
          :show-overflow-tooltip="true"
          :formatter='formatUserNo'
          :label='$t("pc_biz_core_lbl_userNo")'
          prop='userNo'
        ></yxt-table-column>
        <yxt-table-column :label="$t('pc_biz_core_lbl_department')" :show-overflow-tooltip="true" :popover-html="true">
          <template slot-scope="scope">
            <span v-if="!scope.row.deptName">--</span>
            <yxtbiz-dept-name v-else-if='isOpenData' :name='scope.row.deptName' />
            <span v-else>{{scope.row.deptName}}</span>
          </template>
        </yxt-table-column>
        <yxt-table-column
          :show-overflow-tooltip="true"
          :label='$t("pc_gwnl_global_lbl_position")'
          prop='positionName'
        ></yxt-table-column>
      </yxt-table>
      <yxt-row type='flex' align='middle' class='yxtbiz-user-selector-mask mt16'>
        <yxt-row class="col-flex-1" type='flex' align='middle'>
           <yxt-button
              class='lh32 yxtbiz-btn-search-all'
              :class="isSearchAll ? 'color-primary-4 disabled' : ''"
              type='text'
              v-if="showFilterAll"
              @click='searchAll'
            >{{ isCancelSelect ? $t('pc_biz_udp_btn_cancelFilter') : $t('biz_udp_all_filter_results') }}</yxt-button><div class="yxtbiz-loading__all" v-loading="isSearchAll"></div>
        </yxt-row>
        <yxt-pagination
          class='pull-right'
          @size-change='sizeChange'
          @current-change='pageChange'
          :current-page.sync='page'
          :page-size='pager.limit'
          simple-total
          layout='total, prev, pager, next'
          :total='count'
        ></yxt-pagination>
      </yxt-row>
    </div>
  </div>
</template>

<script>
import {
  getUserList
} from '../service';
import resizeTable from '../../mixins/resizeTable';
import openDataMixin from '../../mixins/openData';

export default {
  mixins: [resizeTable, openDataMixin],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'persons'
    },
    scope: {
      type: Number
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    },
    positionIds: {
      type: Array,
      default: () => []
    },
    gradeIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedParams: [],
      isSearchAll: false,
      orgInvalid: false, // 是否全部禁用，如果机构全部禁用了，则不能搜索
      refTable: 'userTable',
      loading: false,
      users: [],
      count: 0,
      searchValue: '',
      isCancelSelect: false,
      showFilterAll: false, // 是否显示筛选所有
      totalPage: 0,
      tableHeight: 0,
      page: 1,
      userData: {
        navCode: this.functionCode,
        dataPermissionCode: this.dataPermissionCode,
        searchKey: '',
        positionIds: this.positionIds,
        gradeIds: this.gradeIds
      },
      pager: {
        limit: 10,
        offset: 0
      },
      selectedPersons: {},
      spares: [],
      formatUserNo: row => {
        return row.userNo || '--';
      }
    };
  },
  created() {
    this.formatUsers(this.value);
    this.getUserData();
  },
  methods: {
    formatUsers(users) {
      this.selectedPersons = {};
      users.forEach(user => {
        this.selectedPersons[user.id] = user;
      });
    },
    getUserData() {
      if (this.orgInvalid) return;
      const userData = Object.assign({}, this.userData, {dynamicSearch: JSON.parse(JSON.stringify(this.spares))});
      // 把 dynamicSearch 数组中的list字段去除掉
      userData.dynamicSearch.forEach(item => delete item.list);
      delete userData.name; // 查找人不需要筛选器名字
      this.userData = userData;
      this.loading = true;
      this.isCancelSelect = false;
      getUserList(userData, this.pager).then(result => {
        if (this.orgInvalid) return;
        if (result.datas.length !== 0) {
          // 搜索条件不为空，展示筛选全部按钮
          this.showFilterAll = true;
        } else {
          this.showFilterAll = false;
        }
        this.loading = false;
        this.users = result.datas;
        this.users.forEach(user => {
          user.nodeType = this.type;
        });
        this.totalPage = result.paging.pages;
        this.count = result.paging.count;
        this.loading = false;
        this.$nextTick(() => {
          this.checkStatus();
        });
      }).catch(() => {
        this.users = [];
        this.loading = false;
      });
    },
    cancelSelectAll() {
      getUserList(Object.assign({}, this.userData), {offset: 0, limit: this.count})
        .then(res => {
          this.isCancelSelect = false;
          const list = res.datas;
          list.forEach(user => {
            delete this.selectedPersons[user.id];
          });
          this.updateUsers(list, false);
        });
    },
    searchAll() {
      if (this.isCancelSelect) {
        return this.cancelSelectAll();
      }
      const limitCount = 5000;
      let count = 0;
      const len = Math.ceil(this.count / limitCount);
      if (len > 0) {
        this.isSearchAll = true;
      }
      let postData = Object.assign({}, this.userData);
      for (let i = 0; i < len; i++) {
        getUserList(Object.assign({}, postData), { limit: limitCount, offset: limitCount * i })
          .then(result => {
            const list = result.datas;
            count++;
            if (count >= len) {
              this.isCancelSelect = true;
              this.isSearchAll = false;
            }
            list.forEach(user => {
              user.nodeType = this.type;
              this.selectedPersons[user.id] = user;
            });

            this.updateUsers(list, true);
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    checkStatus() {
      if (this.value.length === 0) {
        this.isCancelSelect = false;
      }
      this.users.forEach(user => {
        if (this.selectedPersons.hasOwnProperty(user.id)) {
          this.$refs['userTable'].toggleRowSelection(user, true);
        } else {
          this.$refs['userTable'].toggleRowSelection(user, false);
        }
      });
    },
    search() {
      this.userData.searchKey = this.searchValue;
      this.pager.offset = 0;
      this.page = 1;
      this.getUserData();
    },
    selectAllUser(items) {
      let isAdd = items.length !== 0;
      this.users.forEach(user => {
        user.orgName = this.userData.targetOrgName;
        if (!isAdd) {
          delete this.selectedPersons[user.id];
        } else {
          this.selectedPersons[user.id] = user;
        }
      });

      this.updateUsers(this.users, isAdd);
    },
    selectUser(item, row) {
      let isAdd = item.some(v => {
        return v.id === row.id;
      });
      if (item.length === 0) {
        isAdd = false;
        delete this.selectedPersons[row.id];
      } else {
        this.selectedPersons[row.id] = row;
      }
      row.orgName = this.userData.targetOrgName;
      this.updateUsers(row, isAdd);
    },
    sizeChange(size) {
      this.userData.limit = size;
      this.page = 1;
      this.pager.offset = 0;
      this.getUserData();
    },
    updateUsers(items, isAdd) {
      this.$emit('input', Object.values(this.selectedPersons));
      this.$emit('update', this.type, items, isAdd);
    },
    pageChange(page) {
      this.page = page;
      this.pager.offset = (page - 1) * this.pager.limit;
      this.getUserData();
    },
    formatSelectedFromData(datas) {
      return [].concat(datas).map((data) => {
        if (data.db === 'hireDate' || data.db === 'birthday') {
          return {
            ...data,
            data: [data.start || '', data.end || '']
          };
        }
        return data;
      });
    }
  },
  watch: {
    value(v) {
      this.formatUsers(v);
      this.checkStatus();
    },
    searchValue(value) {
      if (value.length > 20) {
        this.searchValue = value.substring(0, 20);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.yxtbiz-user-selector-filter-right .yxt-col-12 {
  height: 56px;
}
</style>
